<template lang="pug">
.ChallengeTopPage
  .content
    .result
      .pane.leftPane
        .best
          .title あなたのベスト記録

          km-rank-badge.badge(
            :score="challengeResult.best.score"
            :labelEnabled="true"
          )

          .stats
            .speed
              .label 入力速度
              .value {{challengeResult.best.score | toFixed(0) }}文字/10分
            .inputWords
              .label 入力文字数
              .value {{challengeResult.best.inputCount}}文字

            .inputTime
              .label 入力時間
              .value {{challengeResult.best.spendTime}}秒

            .backSpaceCount
              .label バックスペース<br>使用回数
              .value {{challengeResult.best.backspaceCount}}回
            .typeMissCount
              .label 入力ミス回数
              .value {{challengeResult.best.wrongLogs.length}}回

            .time {{ challengeResult.best.date }} に記録更新
      .pane.rightPane
        km-challenge-ranking(
          :title="this.embedded ? 'みんなの月間ランキング' : 'みんなのランキング'"
          :ranking="ranking"
        )
    km-button.challengeButton(
      styleName="primary"
      size="large"
      @click="handleChallengeButtonClick"
    ) 挑戦
  km-loading-overlay(
    v-if="assetLoaded === false"
    :queuedAssets="assets"
    :loadedAssets="loadedAssets"
  )
  km-footer(
    title="測定チャレンジ"
    subTitle="いまの入力速度を確かめてみよう"
    :challengeResult="challengeResult"
    :navigationDisabled="embedded"
  )

</template>

<script>
import { mapState, mapActions } from 'vuex'
import RankBadge from '@/components/shared/RankBadge'
import ChallengeRanking from '@/components/shared/ChallengeRanking'
import firebase from 'firebase'
import FirebaseService from '../services/FirebaseService'
export default {
  name: 'challenge-top-page',
  components: {
    'km-rank-badge': RankBadge,
    'km-challenge-ranking': ChallengeRanking
  },
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    toFixed: function(value, length) {
      return value.toFixed(length)
    }
  },
  data() {
    return {
      assetLoaded: null,
      assets: [
        { type: 'image', path: require('@/assets/scroll.svg') },
        { type: 'image', path: require('@/assets/scroll_body.png') },
        { type: 'image', path: require('@/assets/scroll_left.png') },
        { type: 'image', path: require('@/assets/scroll_right.png') },
        { type: 'image', path: require('@/assets/badge_1.png') },
        { type: 'image', path: require('@/assets/badge_2.png') },
        { type: 'image', path: require('@/assets/badge_3.png') },
        { type: 'image', path: require('@/assets/badge_4.png') },
        { type: 'image', path: require('@/assets/badge_5.png') },
        { type: 'image', path: require('@/assets/badge_6.png') },
        { type: 'image', path: require('@/assets/badge_7.png') },
        { type: 'image', path: require('@/assets/badge_8.png') },
        { type: 'image', path: require('@/assets/badge_9.png') },
        { type: 'image', path: require('@/assets/bg_challenge.jpg') },
        { type: 'sound', path: '/app/static/sounds/bgm_yuttari.mp3' },
        { type: 'sound', path: '/app/static/sounds/bgm_challenge.mp3' }
      ],
      ranking: []
    }
  },
  computed: {
    ...mapState('User', {
      challengeResult: state => state.challenge_result
    }),
    ...mapState('Assets', {
      loadedAssets: state => state.assets
    })
  },
  methods: {
    ...mapActions('Sound', ['playBGM', 'stopBGM']),
    ...mapActions('Assets', ['fetchAssets', 'isAssetLoaded']),
    async load() {
      try {
        this.assetLoaded = await this.isAssetLoaded('challengeTop')
        await this.fetchAssets({
          currentPage: 'challengeTop',
          assets: this.assets
        })
        setTimeout(() => {
          this.assetLoaded = true
        }, 500)
      } catch (e) {
        alert('読み込みエラー')
        this.$router.push('/')
      }
    },
    getRanking() {
      this.ranking = []
      firebase
        .firestore()
        .collection('scores')
        .where('status', '==', true)
        .limit(100)
        .orderBy('score', 'desc')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(docs => {
            this.ranking.push({
              name: docs.data().name,
              score: docs.data().score,
              backSpaceCount: docs.data().backspaceCount,
              date: docs.data().date
            })
          })
        })
    },
    handleChallengeButtonClick() {
      this.$router.push(
        (this.embedded ? '/embedded' : '') + '/challenge/player'
      )
    }
  },
  async mounted() {
    await this.load()
    this.playBGM('bgmMenu')
    if (this.embedded) FirebaseService.init('embedded')
    setTimeout(this.getRanking(), 5000)
  }
}
</script>

<style lang="scss" scoped>
.ChallengeTopPage {
  background: rgba(75, 61, 44, 0.8);
  height: 100%;
  width: 100%;
  background: url(../assets/bg_challenge.jpg) no-repeat;
}

.content {
  height: calc(100% - 80px);
  text-align: center;
}

.result {
  display: flex;
}

.pane {
  margin: 40px auto;
  padding: 20px;
  min-height: calc(100% - 120px);
  border: 3px solid #000;
  background: rgba(255, 255, 255, 0.8);
  overflow: scroll;

  &.leftPane {
    width: calc(45% - 40px);
  }
  &.rightPane {
    width: calc(55% - 40px);
  }
}

.best {
  text-align: center;

  .title {
    margin: 0 0 20px 0;
    font-size: 2.5rem;
    font-weight: bold;
  }

  .badge {
    margin: 0 0 40px 0;
    width: 100px;
    height: 100px;
  }

  .stats {
    margin: 0 10px;

    .speed,
    .inputWords,
    .inputTime,
    .backSpaceCount,
    .typeMissCount {
      display: inline-flex;
      align-items: center;
      margin: 5px;
      padding: 10px;
      width: calc(100% - 10px);
      height: 50px;
      border: 2px solid #333;
      background: #fff;
      vertical-align: top;
      border-radius: 5px;

      .label {
        width: 50%;
        text-align: left;
        font-size: 1.4rem;
        line-height: 1.2;
      }

      .value {
        width: 55%;
        text-align: right;
        font-size: 2rem;
      }
    }

    .inputWords,
    .inputTime,
    .backSpaceCount,
    .typeMissCount {
      width: calc(50% - 10px);
    }

    .backSpaceCount,
    .typeMissCount {
      margin-bottom: 20px;
    }

    .time {
      margin: 0 5px 0;
      text-align: right;
    }
  }
}

.challengeButton {
  display: inline-block;
  width: 300px;
}
</style>
